module.exports = {
          srcSet: __webpack_public_path__ + "a1bf18f6c77da68a266873b03f880b31-252.png"+" 252w",
          images:[ {path: __webpack_public_path__ + "a1bf18f6c77da68a266873b03f880b31-252.png",width: 252,height: 93}],
          src: __webpack_public_path__ + "a1bf18f6c77da68a266873b03f880b31-252.png",
          toString:function(){return __webpack_public_path__ + "a1bf18f6c77da68a266873b03f880b31-252.png"},
          
          width: 252,
          height: 93
        }